import { BaseBus } from "./BaseBus";
import { OrderDetailsBus } from "./OrderDetailsBus";
import { CommonFunctions } from "../static/common-functions";
import { OrderReceiveDetailsBus } from "./OrderReceiveDetailBus";
import { DateFunctions } from "../static/date-functions";

export class OrderReceiveBus extends BaseBus
{
    CID(): any {
        return this.orderReceiveId;
    }
    constructor(data: OrderReceiveBus) {
        super(data);
    }
    initialize(data: OrderReceiveBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.dateReceived = CommonFunctions.getDate(data.dateReceived);
        }
        catch {

        }

    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setFromForm(data: OrderReceiveBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (this.hasId) {
            this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.dateReceived = DateFunctions.getDateTimeWithUTCOffset(this.dateReceived);
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(DateFunctions.getDateNow());
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.receivedById = personId;
        this.dateReceived = date;
    }
    orderReceiveId: any;
    orderId: any;
    dateReceived: Date;
    receivedById: any;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    orderDetails: OrderDetailsBus[];
    orderReceiveDetails: OrderReceiveDetailsBus[];
    orderReceiveHistory: OrderReceiveBus[];
}
